"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var generateAndRenderHardcodedCreative_1 = __importDefault(require("../utils/generateAndRenderHardcodedCreative"));
var hasBids_1 = __importDefault(require("../utils/hasBids"));
var makeSafeFrame_1 = __importDefault(require("../utils/makeSafeFrame"));
var bidderHasCreative_1 = require("../utils/bidderHasCreative");
var getBestBid_1 = __importDefault(require("../utils/getBestBid"));
var getBidFormat_1 = __importDefault(require("../utils/getBidFormat"));
var normalizeBids_1 = require("../utils/normalizeBids");
var getPrebidAdUnits_1 = require("./getPrebidAdUnits");
var configurePrebid_1 = require("./configurePrebid");
var getAdCommentFromPrebidBid_1 = require("./getAdCommentFromPrebidBid");
var getAdzerkOverrides_1 = __importDefault(require("../utils/getAdzerkOverrides"));
var getAdzerkPartnerFields_1 = __importDefault(require("../utils/getAdzerkPartnerFields"));
var lodash_merge_1 = __importDefault(require("lodash.merge"));
var loadKevel_1 = __importDefault(require("./loadKevel"));
// TODO combine with code in shouldShowAd and move to external common-utils package
var isEmptyObject = function (object) {
    return (!object ||
        Object.keys(object).length === 0 ||
        Object.getPrototypeOf(object) !== Object.prototype);
};
// load a header bidding add using prebid
function injectReturnedAdvertisementIntoDOM(_a) {
    var _b;
    var prebidJS = _a.prebidJS, placement = _a.placement, bestBid = _a.bestBid;
    var dimensions = bestBid.dimensions.split("x");
    var width = dimensions[0];
    var height = dimensions[1];
    var container = document.getElementById(placement);
    var frame = (0, makeSafeFrame_1.default)(placement, width, height); //rename this?
    if (frame && container) {
        container.appendChild(frame);
        var iframeDoc = (_b = frame.contentWindow) === null || _b === void 0 ? void 0 : _b.document;
        prebidJS.renderAd(iframeDoc, bestBid.source_bid.adId);
        var htmlComment = document.createComment((0, getAdCommentFromPrebidBid_1.getAdCommentFromPrebidBid)(bestBid.source_bid) //rename getAd to createAd ?
        );
        container.insertBefore(htmlComment, frame);
    }
}
function loadHbAdPrebid(adPlacement, testGroups, userGeo, userDeviceType) {
    var _a;
    window.ads = window.ads || {};
    // var __adConfig = window.__cpAdConfig || {};
    var placementOpts = adPlacement && adPlacement.placements;
    if (!placementOpts) {
        console.error("loadHbAdPrebid called with no placements v:".concat((_a = window.wattpad) === null || _a === void 0 ? void 0 : _a.revision));
        return false;
    }
    // TODO: VERIFY CAN DELETE ME
    // if (!__adConfig) {
    //   console.error(
    //     `__adConfig undefined p:${Object.keys(placementOpts).join(" ")} v:${
    //       wattpad.revision
    //     }`
    //   );
    //   return false;
    // }
    var prebidJS = window.pbjs || {};
    window.pbjs = prebidJS;
    prebidJS.que = prebidJS.que || [];
    Object.keys(placementOpts).forEach(function (placement) {
        var PREBID_TIMEOUT = 1000;
        var adUnits = (0, getPrebidAdUnits_1.getPrebidAdUnits)([placement], testGroups, userGeo, userDeviceType);
        // functions pushed to que will be executed immediate if prebid has loaded, or delay
        // until predid loads, it hasn't been yet.
        prebidJS.que.push(function () {
            (0, configurePrebid_1.configurePrebid)(prebidJS, testGroups);
            prebidJS.removeAdUnit(); // clear adunits, they stick around
            prebidJS.addAdUnits(adUnits);
            var innerPlacement = placementOpts[placement];
            if (typeof window.__atha !== "undefined") {
                var id = window.__atha.sendRequest(placement, "prebid", innerPlacement);
                /**
                 * TODO: Other ATHA events rely on this window.ads setup.
                 * We should possibly rethink around how we're defining this,
                 * or how we're trying to pluck information from it in future calls
                 * if it doesn't exist.
                 */
                window.ads[placement] = __assign(__assign({}, window.ads[placement]), { pbRequestId: id });
            }
            prebidJS.requestBids({
                timeout: PREBID_TIMEOUT,
                bidsBackHandler: function (bids) {
                    var _a;
                    var bidFormat = (0, getBidFormat_1.default)("prebid");
                    var normalizedBids = (0, normalizeBids_1.normalizeBids)(bids && placement in bids ? bids[placement].bids : [], bidFormat);
                    var bestBid = (0, getBestBid_1.default)(normalizedBids, placement, false);
                    // ATHA log auction result REMOVED (SEND Auction result function)
                    if (typeof window.__atha !== "undefined") {
                        var id = window.__atha.sendAuctionResult(placement, bestBid, normalizedBids);
                        window.ads[placement][bidFormat.responseIdField] = id;
                    }
                    if (testGroups === null || testGroups === void 0 ? void 0 : testGroups.USE_KEVEL) {
                        var advertiserId = "2014727"; // Prebid's advertiser acc't in Adzerk
                        var overrides_1 = !isEmptyObject(bestBid)
                            ? (0, getAdzerkOverrides_1.default)(bestBid, advertiserId)
                            : {}; // Processed HB Overrides
                        var displayTargeting = (_a = innerPlacement === null || innerPlacement === void 0 ? void 0 : innerPlacement.targeting) !== null && _a !== void 0 ? _a : {};
                        var headerBiddingKeywords_1 = (displayTargeting === null || displayTargeting === void 0 ? void 0 : displayTargeting.category)
                            ? window.wattpad.categoryList[displayTargeting.category]
                            : "";
                        var partnerFields = !isEmptyObject(bestBid)
                            ? (0, getAdzerkPartnerFields_1.default)(bestBid)
                            : {}; // HB Targeting Params
                        var mergedTargeting = (0, lodash_merge_1.default)(displayTargeting, partnerFields);
                        // extract to bid helper
                        // need to understand better the presence of source_bid. Maybe it controls how
                        // we treat attributes here.
                        var getHeaderBiddingBidder = function (bid) {
                            if (isEmptyObject(bid)) {
                                return "";
                            }
                            if (bid.adserverTargeting) {
                                return bid.adserverTargeting.hb_bidder;
                            }
                            else {
                                return bid.source_bid.adserverTargeting.hb_bidder;
                            }
                        };
                        // extract to bid helper
                        var getAdId = function (bid) {
                            var _a;
                            if (isEmptyObject(bid)) {
                                return "";
                            }
                            return (_a = bid.adId) !== null && _a !== void 0 ? _a : bid.source_bid.adId;
                        };
                        var properties_1 = __assign({ hb_bidder: getHeaderBiddingBidder(bestBid), ad_id: getAdId(bestBid) }, mergedTargeting);
                        if (typeof window.__atha !== "undefined") {
                            var id = window.__atha.sendRequest(placement, "kevel", __assign({ zoneId: innerPlacement.zoneId }, innerPlacement));
                            window.ads[placement] = __assign(__assign({}, window.ads[placement]), { requestId: id });
                        }
                        window.ados = window.ados || {};
                        window.ados.run = window.ados.run || [];
                        window.ados.run.push(function () {
                            prebidJS.que.push(function () {
                                (0, loadKevel_1.default)({
                                    adUnitId: placement,
                                    innerPlacement: innerPlacement,
                                    properties: properties_1,
                                    overrides: overrides_1,
                                    headerBiddingKeywords: headerBiddingKeywords_1,
                                });
                            });
                        });
                    }
                    else {
                        // if there's no bid
                        if (!(0, hasBids_1.default)({ bids: bids, placement: placement })) {
                            return (0, generateAndRenderHardcodedCreative_1.default)(placement);
                        }
                        // If any bidders return any creatives
                        if ((0, bidderHasCreative_1.bidderHasCreative)(bestBid)) {
                            // inject returned advertisement and audit comment into DOM
                            injectReturnedAdvertisementIntoDOM({
                                prebidJS: prebidJS,
                                placement: placement,
                                bestBid: bestBid,
                            });
                            // fire ATHA impression
                            if (typeof window.__atha !== "undefined") {
                                window.__atha.sendImpression(placement, "n/a", bestBid.source_bid.bidder, bestBid.cpi || 0, bestBid.dimensions);
                            }
                        }
                        else {
                            return (0, generateAndRenderHardcodedCreative_1.default)(placement);
                        }
                    }
                },
            });
        });
    });
}
exports.default = loadHbAdPrebid;
